import { Pipe, PipeTransform } from '@angular/core';
import { formatDobMdY } from '../utils/dob-display.util';

@Pipe({
  name: 'dobFormat',
})
export class DobFormatPipe implements PipeTransform {
  transform(value: any): string {
    const formatted = formatDobMdY(value, true);
    if (formatted) {
      return formatted;
    }

    const str = String(value ?? '').trim();
    const dashMatch = /^(\d{2})-(\d{2})-(\d{4})$/.exec(str);
    if (dashMatch) {
      return `${dashMatch[1]}/${dashMatch[2]}/${dashMatch[3]}`;
    }

    return str;
  }
}

